module.exports = __webpack_public_path__ + "fonts/Young.6f3ebc2e.ttf";